import { VueModule } from '@Foundation/utilities';
import RoutineV2 from './code/Scripts/components/routine-V2';

export default VueModule({
  components: {
    RoutineV2
  }
});
